import { isNotEmpty } from '@monorepo/shared/utils/validators';
import { FormTemplateFieldConditionalRule } from 'mapistry-shared';
import { useCallback } from 'react';
import {
  isContainsMatchOperator,
  isExactMatchOperator,
} from '../conditionalOperatorConsts';

function findValueWithoutExactMatch(
  values: string[],
  options: Set<string>,
): string | undefined {
  return values.find((value) => !options.has(value));
}

function findValueWithoutContainsMatch(
  values: string[],
  options: string[],
): string | undefined {
  return values.find((value) => !options.some((v) => v.includes(value)));
}

export const useCanOptionsFulfillConditionalRules = (
  conditionalRules: FormTemplateFieldConditionalRule[] = [],
) =>
  useCallback(
    (newFieldOptions: string[]) => {
      const fieldOptionsArray = newFieldOptions.map((v) => v.trim());
      const fieldOptionsSet = new Set(fieldOptionsArray);

      for (let i = 0; i < conditionalRules.length; i++) {
        const rule = conditionalRules[i] as FormTemplateFieldConditionalRule;

        const trimmedConditionalValues =
          rule?.conditionalFieldValues
            ?.filter(isNotEmpty)
            .map((value) => value.trim()) || [];

        if (isExactMatchOperator(rule?.operator)) {
          const conditionalValueNotIncludedInOptions =
            findValueWithoutExactMatch(
              trimmedConditionalValues,
              fieldOptionsSet,
            );
          if (conditionalValueNotIncludedInOptions) {
            return `Any options referenced in the conditions of another field must be included ("${conditionalValueNotIncludedInOptions}").`;
          }
        }

        if (isContainsMatchOperator(rule?.operator)) {
          const conditionalValueNotIncludedInOptions =
            findValueWithoutContainsMatch(
              trimmedConditionalValues,
              fieldOptionsArray,
            );

          if (conditionalValueNotIncludedInOptions) {
            return `Any options referenced in the conditions of another field must be included (must have at least one option that includes "${conditionalValueNotIncludedInOptions}").`;
          }
        }
      }

      return undefined;
    },
    [conditionalRules],
  );
